<template>
  <tr @keyup.enter="filterChanged()" class="exsi-filter">
    <th/>
    <th class="input-wrapper">
      <b-form-select
          :options="getFilterOptions('State')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'State')"
          v-model="filterValues['State']"
          placeholder="ANY"
          inputId="State"
          clearable/>
    </th>
    <th></th>
    <th class="input-wrapper">
      <!--<b-input-group>
        <b-form-input v-model="filterValues['Name']" placeholder="Name"></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" value="Name" content="Exact phrase" v-tippy="{arrow : true}"
                 aria-label="Строгий поиск">
        </b-input-group-append>
      </b-input-group>-->
      <b-form-select
          :options="getFilterOptions('Name')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'Name')"
          v-model="filterValues['Name']"
          placeholder="ANY"
          inputId="Name"
          id="Name"
          clearable/>
      <SelectSearch :handler-func="changeFilterValue" field="Name" :options="getFilterOptions('Name')"></SelectSearch>
    </th>
    <th class="input-wrapper">
      <b-form-select
          :options="getFilterOptions('Entity')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'Entity')"
          v-model="filterValues['Entity']"
          placeholder="ANY"
          inputId="Entity"
          clearable/>
    </th>
    <th class="input-wrapper">
      <b-input-group>
        <b-form-input v-model="filterValues['Ip']" placeholder="IP"></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" value="Ip" content="Exact phrase" v-tippy="{arrow : true}"
                 aria-label="Строгий поиск">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th class="input-wrapper" style="max-width: 5rem;">
      <b-input-group>
        <b-form-input v-model="filterValues['Cpu']" placeholder="CPU"></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" value="Cpu" content="Exact phrase" v-tippy="{arrow : true}"
                 aria-label="Строгий поиск">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th class="input-wrapper" style="max-width: 6rem;">
      <b-input-group>
        <b-form-input v-model="filterValues['Ram']" placeholder="RAM" number></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" value="Ram" content="Exact phrase" v-tippy="{arrow : true}"
                 aria-label="Строгий поиск">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
      <!--      <b-input-group>-->
      <!--        <b-form-input v-model="ssdHhdFilter" placeholder="SSD/HDD"></b-form-input>-->
      <!--        <b-input-group-append is-text>-->
      <!--          <input type="checkbox" v-model="ssdHhdFilterExact" :value="false" content="Exact phrase"-->
      <!--                 v-tippy="{arrow : true}"-->
      <!--                 aria-label="Строгий поиск">-->
      <!--        </b-input-group-append>-->
      <!--      </b-input-group>-->
    </th>
    <th class="input-wrapper">
      <b-form-select
          :options="getFilterOptions('DcName')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'DcName')"
          v-model="filterValues['DcName']"
          placeholder="ANY"
          inputId="DcName"
          id="DcName"
          clearable/>
      <SelectSearch :handler-func="changeFilterValue" field="DcName" :options="getFilterOptions('DcName')"></SelectSearch>
    </th>
    <th class="d-flex">
        <span class="cel-buttons">
          <span class="icon-search" @click="filterChanged()" title="Apply filters"><i class="fa fa-solid fa-search"></i></span>
           <span class="icon-clear" @click="clearFilter()" title="Clear filters"> <font-awesome-icon icon="recycle"
                                                                                                     class="icon alt"/></span>
        </span>
    </th>
    <th/>

  </tr>

</template>
<script>
import _ from "lodash";
import SelectSearch from "@/components/filters/SelectSearch.vue";

function debounce(that, fn, delay) {
  let timeoutID = undefined;
  return () => {
    clearTimeout(timeoutID);
    const args = arguments;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
}

export default {
  name: "ServerFilters",
  components: {SelectSearch},
  emits: ['deleteItems'],
  props: {
    filterExactProp: {
      type: Array,
      default: []
    },
    result: Array,
    itemsSelectedCount: {
      type: Number,
      default: 0
    },
    filter: {
      type: Array,
      default: function () {
        return {
          name: 'Name',
          value: '',
          w: 100
        }
      }
    },
    columns: {
      type: Array,
      default: () => {
        return [
          {
            name: '',
            value: '',
          }
        ]
      }
    },
    filterValues: {
      type: Object,
      default: function () {
        return {
          Name: '',
        }
      }
    }
  },
  data() {
    return {
      filters: [],
      queryFilter: [],
      filterExact: this.filterExactProp,
      ssdHhdFilter: null,
      ssdHhdFilterExact: false,
    };
  },
  methods: {
    changeFilterValue(event, filter) {
      this.filterValues[filter] = event === null ? "" : event
      if ('DcName' == filter && this.filterValues['DcId'] !== undefined && this.filterValues['DcId'] !== null) {
        this.filterValues['DcId'] = null;
        delete this.filterValues['DcId'];
      }
      this.filterChanged()
      if (this.filterValues[filter] !== undefined && this.filterValues[filter] !== null) {
        this.filterValues[filter] = event;
      }
    },
    actionDelete() {
      this.$emit('deleteItems')
    },
    getUnnamedFilter(data) {
      let condition;
      let field;
      let value;
      if (Object.prototype.hasOwnProperty.call(data, 'Data') &&
          Object.prototype.hasOwnProperty.call(data, 'Condition')) {
        condition = data['Condition'];
        field = Object.keys(data['Data'])[0];
        value = data['Data'][field];
      }
      let fieldExist = false;
      for (let filterIndex in this.filter) {
        if (Object.prototype.hasOwnProperty.call(this.filter[filterIndex], 'name')) {
          if (field === this.filter[filterIndex].name) {
            fieldExist = true;
          }
        }
      }
      if (!fieldExist) {
        return ' ' + field + ' ' + condition + ' ' + value;
      }
      return '';
    },
    getFilterOptions(name) {
      const options = this.filterComputed.find(filter => filter.name === name)?.options
      if (name === 'State') {
        _.forEach(options, (option) => {

          if (option.label === 'OK') {
            option.label = "🟢OK"
          } else if (option.label === 'NO PING') {
            option.label = "🔴OFF"
          } else if (option.label === 'ERROR') {
            option.label = "⭕️ERROR"
          } else if (option.label === 'TIMEOUT') {
            option.label = "⌛TIMEOUT"
          } else if (option.label === 'FAIL_AUTH') {
            option.label = "🔐FAIL_AUTH"
          } else if (option.label === null) {
            option.label = "0️⃣️NULL"
          }
        })
      } else if (name === 'Entity') {
        _.forEach(options, (option) => {
          if (option.label.toLowerCase() === 'ipmi') {
            option.label = "🔌 IPMI"
          } else if (option.label.toLowerCase() === 'baremetal') {
            option.label = "🗿 Baremetal"
          } else if (option.label.toLowerCase() === 'esxi') {
            option.label = " 📟 ESXi"
          } else if (option.label.toLowerCase() === 'vps') {
            option.label = "🌩 VPS"
          } else if (option.label.toLowerCase() === 'proxmox') {
            option.label = "📻 Proxmox"
          }
        })
      }

      return options;
    },
    filterChanged() {
      this.debounced();
    },
    buttonFilter(filterConfig) {
      if (Object.keys(filterConfig || {}).length === 0) {
        return
      }
      if (!this.buttonCheck(filterConfig)) {
        this.pushFilters(filterConfig);
      } else {
        this.popFilters(filterConfig);
      }
      this.filterSend();
    },
    pushFilters(filterConfig) {
      for (let filterIdx in filterConfig) {
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          continue;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (value) {
          this.filterValues[field] = value;
        }
      }
    },
    popFilters(filterConfig) {
      let filterCopy = [];
      for (let filterIdx in filterConfig) {
        let data = {};
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          return true;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (Object.keys(this.filterValues).includes(field)) {
          this.filterValues[field] = '';
        }
        data[field] = value;
        let filterExist = false;
        let lastFilterItem = {};
        for (let filterUsedIdx in this.filters) {
          let fieldUsed;
          let valueUsed;
          if (!this.filters[filterUsedIdx]) continue;
          if (this.filters[filterUsedIdx] === undefined) {
            console.log("WTF");
          }
          for (let fieldName in this.filters[filterUsedIdx].Data) {
            fieldUsed = fieldName;
            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
          }
          if (this.filters[filterUsedIdx].Condition !== filterConfig[filterIdx].Condition &&
              fieldUsed != field && value != valueUsed) {
            filterExist = true;
            lastFilterItem = this.filters[filterUsedIdx];
          }
        }
        if (filterExist) {
          filterCopy.push(lastFilterItem);
          this.filterValues[field] = value;
        }
      }
      this.filters = filterCopy;
    },
    onRouteChange() {
      this.queryFilter = [];
      this.filters = [];
      this.$emit('onInit', this.filters);
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    filterSend() {
      let currentQuery = this.$route.query;
      let newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] != '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (this.filterExact.includes(FieldName)) {
            newFilters.push({
              Condition: "=",
              Data: data,
            });
          } else {
            newFilters.push({
              Condition: "ilike",
              Data: data,
            });
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(newFilters)}});
        this.filters = newFilters;
        this.$emit('onChanged', newFilters)
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
  },
  watch: {
    '$route': 'onRouteChange',
    filter: function (val) {
      const $this = this
      val.map((filter) => {
        $this.filterOptions[filter.name] = filter.options ?? []
      })
    },
    ssdHhdFilter: function (val) {
      if (val !== null || val !== '') {
        this.filterValues['ssd/hdd'] = val
      }
    },
    ssdHhdFilterExact: function (val) {
      if (val) {
        this.filterExact.push('ssd/hdd')
      }
    }
  },
  computed: {
    filterComputed: function () {
      return this.filter
    }
  },
  created: function () {
    this.$emit('onInit', this.filters);
    this.debounced = debounce(this, this.filterSend, 200);
  },
}
</script>

<style scoped>

</style>